/**
 * Horizontal click-and-drag scrolling for pill rows and similar overflow tracks.
 * Clicks on links still navigate unless the pointer moved horizontally while dragging.
 */
(function () {
  const SELECTOR = [
    '.shopify-section--main-collection .wd-yves-toolbar-pills.scroll-area',
    '.shopify-section--main-collection .wd-yves-toolbar-subcollection-pills.scroll-area',
    '.wd-header-category-pills__track',
  ].join(', ');

  const DRAG_THRESHOLD_PX = 4;
  const finePointerQuery = window.matchMedia('(pointer: fine)');

  function bindScrollArea(el) {
    if (el.dataset.wdDragScrollInit === 'true') {
      return;
    }

    if (!finePointerQuery.matches) {
      return;
    }

    el.dataset.wdDragScrollInit = 'true';

    el.addEventListener('mousedown', (event) => {
      if (event.button !== 0) {
        return;
      }

      const dragPosition = {
        x: event.clientX,
        left: el.scrollLeft,
      };

      let isDragging = false;

      const onMouseMove = (moveEvent) => {
        const dx = moveEvent.clientX - dragPosition.x;

        if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD_PX) {
          isDragging = true;
          el.classList.add('is-wd-drag-scrolling');
          el.style.scrollSnapType = 'none';
        }

        if (!isDragging) {
          return;
        }

        moveEvent.preventDefault();
        el.scrollLeft = dragPosition.left - dx;
      };

      const onClickCapture = (clickEvent) => {
        if (Math.abs(clickEvent.clientX - dragPosition.x) > DRAG_THRESHOLD_PX) {
          clickEvent.preventDefault();
          clickEvent.stopImmediatePropagation();
        }
      };

      const onMouseUp = () => {
        el.classList.remove('is-wd-drag-scrolling');
        el.style.removeProperty('scroll-snap-type');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      el.addEventListener('click', onClickCapture, { capture: true, once: true });
    });
  }

  function initAll(root) {
    if (!finePointerQuery.matches) {
      return;
    }

    (root || document).querySelectorAll(SELECTOR).forEach(bindScrollArea);
  }

  function boot() {
    initAll();
  }

  finePointerQuery.addEventListener('change', () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      delete el.dataset.wdDragScrollInit;
    });
    boot();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
